<template>
  <div>
    <h4>現在、準備中です。</h4>
    当月のデータは翌月初旬に公開されます。<br>
    お急ぎの場合は担当者または <a
      href="mailto:business@kids-public.co.jp"
      class="mail-to"
    >business@kids-public.co.jp</a> までご連絡ください。なお、前月以前のデータはご覧いただけます。
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "UnpublishedMessagePart"
})
</script>
